import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import OccurrenceLabel from 'ContentComponents/components/cmv2/occurrences/OccurrenceLabel';
import { getFieldFromKey } from 'ContentComponents/components/cmv2/utils';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { DISPLAY_OPTIONS } from 'ContentComponents/components/cmv2/constants';
import { View } from 'foundations-components/components/View';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themeSettings.${key}`;
class NavigationBreadcrumb extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.fieldKey !== nextProps.fieldKey;
  }
  renderBreadCrumbs() {
    const {
      fieldKey,
      fields,
      module,
      onKeyChange
    } = this.props;
    const items = [];
    if (!fieldKey || !fields) {
      return null;
    }
    fieldKey.forEach((keyName, index) => {
      const _key = fieldKey.slice(0, index + 1);
      const _field = getFieldFromKey(fields, _key) || {};
      const {
        display
      } = _field;
      const isDisabled = index === fieldKey.length - 1;

      // if display override renders children inside parent panel, dont make a page for it in breadcrumb
      if (display && display !== DISPLAY_OPTIONS.DRILLDOWN) return;
      if (_field && typeof keyName === 'number') {
        const _value = getDeepValue(module, _key);
        const _label = /*#__PURE__*/_jsx(Link, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: /*#__PURE__*/_jsx(OccurrenceLabel, {
            asString: true,
            defaultLabel: _field.label || `${_value}`,
            field: _field,
            value: _value
          })
        }, _key.join('.'));
        items.push(_label);
      } else if (_field && !_field.occurrence) {
        items.push( /*#__PURE__*/_jsx(Link, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: _field.label
        }, _key.join('.')));
      }
    });
    return items;
  }
  render() {
    const {
      onKeyChange
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "none",
      children: /*#__PURE__*/_jsxs(Breadcrumbs, {
        marginBlockEnd: "200",
        marginBlockStart: "200",
        paddingInlineStart: "500",
        paddingInlineEnd: "500",
        truncateToLevels: 2,
        singleBreadcrumbIsBackLink: false,
        children: [/*#__PURE__*/_jsx(Link, {
          onClick: () => onKeyChange([]),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('patagoniaRootBreadcrumb')
          })
        }), this.renderBreadCrumbs()]
      })
    });
  }
}
export default NavigationBreadcrumb;